import { makeVar } from '@apollo/client'

export const isOpenAllowanceDialogVar = makeVar(false)
